import { previewItems } from '../previewTemplates';

export const getPreviewItems = (selectedPreviewItems) => ({
  items: previewItems[selectedPreviewItems]
    ? previewItems[selectedPreviewItems]
    : previewItems['ourClients']
});
